<p>telangana-state-senior-bad-cham works!</p>
<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Telangana State Senior
                        Badminton Championship 2025 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2><span>Shri G.H. Raisoni Memorial Yonex-Sunrise 11 th Telangana State Senior
                    Badminton Championship 2025 (Men &amp; Women)</span></h2>
        </div>
        <div class="row justify-content-between">
            <div class="col-md-12">
                <p><strong>Event Name:</strong> "Shri G.H. Raisoni Memorial Yonex-Sunrise 11 th Telangana State Senior
                    Badminton Championship 2025 (Men &amp; Women)"</p>
                <p><strong>Dates:</strong> 25th June to 28th June 2025</p>
                <h6>Chief Guests at the Ceremony:</h6>
                <ul class="list-style list-style1 ">
                    <li>Shri Pullela Gopichand – Chief National Coach, India &amp; General Secretary, BAT</li>
                    <li>Shri Sumeet Reddy – International Badminton Player, India</li>
                    <li>Shri Uppala Gupta – President, BAMMD</li>
                    <li>Shri Prabhakar Bhaskar – Secretary, BAMMD</li>
                    <li>Shri P. Vikas Harsha – Treasurer, BAMMD &amp; Organising Secretary</li>
                    <li>Ms. Poonam Pandey – Sports Officer, G.H. Raisoni University</li>
                </ul>
                <h6>Highlights:</h6>
                <p>Selection Tournament for the 87th Senior National Badminton Championship &amp; South Zone 2025.
                </p>

                <p>We are proud to announce the Shri G.H. Raisoni Memorial Yonex-Sunrise 11th Telangana State
                    Senior Badminton Championship 2025, for both Men and Women, serving as a Selection
                    Tournament for the 87th Senior National Badminton Championship and South Zone 2025.</p>

                <p>This prestigious tournament is supported by Raisoni Foundation Sports and Culture, in collaboration
                    with NDBA, and is being held at Vishwamanya Badminton Academy, Multipurpose Indoor Stadium,
                    Railway Sports Complex, Secunderabad (RRC)</p>

                <p>This is the first tournament held under the Raisoni banner in Telangana State, marking a significant
                    milestone in our sports outreach and commitment to nurturing talent across India.</p>

            </div>
        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior8.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior8.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/telangana-state-senior8.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</section>
